// src/hooks/useNotifications.js
import { useAppContext } from '../components/context/AppContext';

/**
 * Global state hook for notifications management
 * Connects to AppContext for centralized state management
 */
export const useNotifications = () => {
    const { state, actions } = useAppContext();
    
    return {
        // State
        notifications: state.notifications || [],
        
        // Actions
        addNotification: actions.addNotification,
        removeNotification: actions.removeNotification,

        // Utility functions
        getNotificationCount: () => state.notifications?.length || 0,

        hasNotifications: () => (state.notifications?.length || 0) > 0,

        getNotificationById: (notificationId) => {
            return state.notifications?.find(notification => notification.id === notificationId);
        }
    };
};

export default useNotifications;
